/*
 * @Author: dongzhuo
 * @Date: 2021-01-18 10:29:30
 * @Description: 路由权限控制(包括初始化路由。登录之后的路由等等)等中间件控制层
 */
import router from "@/router";
import store from "@/store";

import { Message } from "element-ui";
import _this from "@/main";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "./auth";
NProgress.configure({
  showSpinner: false
});
const whiteList = ["/", "/home", "/society", "/user/login", "/society/details", "/campus/details", "/campus"];
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = to.meta && to.meta.title ? to.meta.title : "z-system";
  const hasToken = getToken();
  console.log("this.hastoken:", hasToken);

  if (hasToken) {
    // 有token

    const hasGetUserInfo = store.getters.userInfo; // 取用户信息
    const userData = Object.keys(hasGetUserInfo); // 把用户信息数组化
    console.log("获得token，并开始取用户数据hasGetUserInfo，keys", hasGetUserInfo, userData);
    if (userData.length > 0) {
      // 判断是否有用户信息
      // 存在用户信息 继续执行
      // 校验用户的信息是否完善
      if (store.getters.userName && store.getters.userPhone) {
        next();
      } else {
        Message.error("请完善基本信息后，投递岗位！");
        if (to.path == '/user/info') {
          next();
        } else {
          next("/user/info");
        }
      }
      NProgress.done();
    } else {
      // 不存在用户信息，未登录状态
      try {
        await store.dispatch("user/getInfo");

        next("/user/already");

      } catch (error) {
        await store.dispatch("user/resetToken");
        Message.error(error || "Has Error");
        next("/user/login");
        NProgress.done();
      }

    }



  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 白名单的路由 可以正常执行；
      next();
    } else { // 不在白名单的路由，要跳转到登录页，待修订；
      Message.error("暂未登录，请进行登录操作！")
      next("/user/login");
      NProgress.done();
    }
  }
});
// 处理系统加载资源错误
router.onError(error => {
  const failed = "failed"; // 加载chunk 错误
  const isChunkLoadFailed = error.message.includes(failed);
  if (isChunkLoadFailed) {
    _this.$alert("系统已重新部署，请刷新页面", "温馨提示", {
      confirmButtonText: "确定",
      showClose: false,
      callback: () => {
        window.location.reload();
      }
    });
  }
});


router.afterEach(() => {
  NProgress.done();
});
